import { AGENT_BACKGROUND_MESSAGE_COUNT } from "./types";

export const agentBackGroundMessageCount = (payload) => (dispatch) => {
    dispatch({
        type: AGENT_BACKGROUND_MESSAGE_COUNT,
        payload: payload,
    });
};
